import { createFileRoute } from '@tanstack/react-router';

import { Box } from '@optiro/ui';

import { Show } from '@/modules/PartnerProjects/Show';

export const Route = createFileRoute('/app/partner-projects/$projectId/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  return (
    <Box p="md">
      <Show projectId={projectId} />
    </Box>
  );
}
